export default __webpack_public_path__ + "static/media/ic_discord.be4d716c.svg";